var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/vue/vue": {
		getter: () => (__webpack_require__.e("vendors-node_modules_vue_dist_vue_runtime_esm-bundler_js").then(() => (() => (__webpack_require__("./node_modules/vue/dist/vue.runtime.esm-bundler.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	"webpack/sharing/consume/default/chart.js/chart.js": {
		getter: () => (__webpack_require__.e("vendors-node_modules_chart_js_dist_chart_js").then(() => (() => (__webpack_require__("./node_modules/chart.js/dist/chart.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.5.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "chart.js",
	},
	"webpack/sharing/consume/default/vue-chartjs/vue-chartjs": {
		getter: () => (__webpack_require__.e("node_modules_vue-chartjs_dist_index_js-_31ca1").then(() => (() => (__webpack_require__("./node_modules/vue-chartjs/dist/index.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.3.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue-chartjs",
	},
	"webpack/sharing/consume/default/moment/moment": {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_moment_locale_af_js-node_modules_moment_locale_ar-dz_js-node_modules_mom-582c96"), __webpack_require__.e("node_modules_moment_locale_sync_recursive_")]).then(() => (() => (__webpack_require__("./node_modules/moment/moment.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.30.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "moment",
	},
	"webpack/sharing/consume/default/chartjs-plugin-trendline/chartjs-plugin-trendline": {
		getter: () => (__webpack_require__.e("node_modules_chartjs-plugin-trendline_src_chartjs-plugin-trendline_js").then(() => (() => (__webpack_require__("./node_modules/chartjs-plugin-trendline/src/chartjs-plugin-trendline.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.1.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "chartjs-plugin-trendline",
	},
	"webpack/sharing/consume/default/vue-router/vue-router": {
		getter: () => (__webpack_require__.e("vendors-node_modules_vue-router_dist_vue-router_mjs").then(() => (() => (__webpack_require__("./node_modules/vue-router/dist/vue-router.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue-router",
	},
	"webpack/sharing/consume/default/pinia/pinia": {
		getter: () => (__webpack_require__.e("vendors-node_modules_pinia_dist_pinia_mjs").then(() => (() => (__webpack_require__("./node_modules/pinia/dist/pinia.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "pinia",
	},
	"webpack/sharing/consume/default/vue3-click-away/vue3-click-away": {
		getter: () => (__webpack_require__.e("node_modules_vue3-click-away_dist_module_js").then(() => (() => (__webpack_require__("./node_modules/vue3-click-away/dist/module.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.2.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue3-click-away",
	},
	"webpack/sharing/consume/default/vue-demi/vue-demi": {
		getter: () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_vue_vue"), __webpack_require__.e("node_modules_vue-demi_lib_index_mjs")]).then(() => (() => (__webpack_require__("./node_modules/vue-demi/lib/index.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue-demi",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_vue_vue": [
		"webpack/sharing/consume/default/vue/vue"
	],
	"webpack_sharing_consume_default_chart_js_chart_js": [
		"webpack/sharing/consume/default/chart.js/chart.js"
	],
	"webpack_sharing_consume_default_vue-chartjs_vue-chartjs": [
		"webpack/sharing/consume/default/vue-chartjs/vue-chartjs"
	],
	"webpack_sharing_consume_default_moment_moment": [
		"webpack/sharing/consume/default/moment/moment"
	],
	"webpack_sharing_consume_default_chartjs-plugin-trendline_chartjs-plugin-trendline": [
		"webpack/sharing/consume/default/chartjs-plugin-trendline/chartjs-plugin-trendline"
	],
	"src_bootloader_ts-src_helpers_CompareFunctions_ts-src_components_Cards_CardBase_vue-src_compo-5002d9": [
		"webpack/sharing/consume/default/vue-router/vue-router",
		"webpack/sharing/consume/default/pinia/pinia",
		"webpack/sharing/consume/default/vue3-click-away/vue3-click-away"
	],
	"webpack_sharing_consume_default_vue-demi_vue-demi": [
		"webpack/sharing/consume/default/vue-demi/vue-demi"
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}